import type { PortalClientStatus } from '@wally-reseller/shared';
import { cn } from '@wally-reseller/ui/utils';
import { useT } from '@/lib/i18n';

const TONE: Record<PortalClientStatus, string> = {
  submitted: 'bg-muted text-muted-foreground',
  evidence_requested: 'bg-note text-foreground border-note-border',
  refused: 'bg-muted text-danger',
  withdrawn: 'bg-muted text-muted-foreground',
  in_progress: 'bg-accent-soft text-accent',
  demo_planned: 'bg-accent-soft text-accent',
  demo_done: 'bg-accent-soft text-accent',
  customer: 'bg-success/10 text-success',
  lost: 'bg-muted text-muted-foreground',
};

export function StatusBadge({ status }: { status: PortalClientStatus }) {
  const t = useT();
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded border border-transparent px-1.5 py-px text-xs font-medium',
        TONE[status],
      )}
    >
      {t(`portal.status.${status}`)}
    </span>
  );
}
